export { AvatarStack } from "./AvatarStack"
export type { AvatarStackProps, UINamedStackPerson, UIStackPerson } from "./AvatarStack"
